var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverallChartImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 76,
    viewBox: "0 0 152 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 75.5C12 58.3935 18.8482 41.9877 31.0381 29.8916C43.2279 17.7955 59.7609 11 77 11C94.2391 11 110.772 17.7955 122.962 29.8916C135.152 41.9877 142 58.3935 142 75.5L121.292 75.5C121.292 63.8433 116.626 52.664 108.319 44.4214C100.013 36.1789 88.7471 31.5483 77 31.5483C65.2529 31.5483 53.987 36.1789 45.6805 44.4214C37.3741 52.664 32.7075 63.8433 32.7075 75.5L12 75.5Z",
    fill: "#D4E7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9318 14.4821C68.9625 10.0518 83.0745 9.84379 96.2321 13.8879L90.1047 33.5175C81.1392 30.7619 71.5232 30.9036 62.6442 33.9224L55.9318 14.4821Z",
    fill: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1814 13.8724C109.493 17.9521 121.132 26.1681 129.381 37.309L112.692 49.4767C107.071 41.8852 99.1408 36.2869 90.0702 33.507L96.1814 13.8724Z",
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.371 37.2959C137.683 48.515 142.112 62.102 141.998 76.0261L121.29 75.8585C121.368 66.3706 118.349 57.1124 112.686 49.4677L129.371 37.2959Z",
    fill: "#027A48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.002 76.0077C11.8946 62.4619 16.0877 49.2264 23.9867 38.1783L40.8767 50.069C35.4944 57.5972 32.6372 66.6159 32.7104 75.8459L12.002 76.0077Z",
    fill: "#D92D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9961 38.1652C31.8849 27.1371 43.0675 18.8486 55.9627 14.4716L62.6652 33.9152C53.8784 36.8978 46.2586 42.5455 40.8831 50.0601L23.9961 38.1652Z",
    fill: "#EF6820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 76C1.76213e-06 55.8435 8.00712 36.5126 22.2599 22.2599C36.5126 8.00712 55.8435 2.16247e-06 76 0C96.1564 -2.16247e-06 115.487 8.00711 129.74 22.2599C143.993 36.5126 152 55.8435 152 76L139.84 76C139.84 59.0686 133.114 42.8306 121.142 30.8583C109.169 18.886 92.9314 12.16 76 12.16C59.0686 12.16 42.8306 18.886 30.8583 30.8583C18.886 42.8306 12.16 59.0686 12.16 76L0 76Z",
    fill: "#D4E7FD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3237 38.3452L14.6466 31.317C24.0424 18.4156 37.2663 8.80432 52.438 3.84971L56.1358 15.2237C43.3661 19.3974 32.2353 27.4874 24.3237 38.3452Z",
    fill: "#D4E7FD",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2774 25.7452L27.402 22.4629L27.9966 21.942L30.4353 24.7259L31.881 23.4595L32.3176 23.9579L30.2774 25.7452Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8037 19.1951C35.0919 19.5666 35.2691 19.9388 35.3354 20.3116C35.402 20.6824 35.3702 21.0307 35.2399 21.3565C35.1108 21.6813 34.8953 21.9609 34.5934 22.1951C34.2915 22.4293 33.9666 22.569 33.6187 22.6141C33.2711 22.6573 32.9254 22.601 32.5816 22.4452C32.2381 22.2874 31.9227 22.0234 31.6353 21.653C31.3471 21.2815 31.1698 20.9103 31.1032 20.5395C31.0369 20.1666 31.0683 19.8178 31.1974 19.4929C31.3276 19.1672 31.5437 18.8872 31.8456 18.653C32.1475 18.4188 32.4719 18.2795 32.8186 18.2353C33.1665 18.1901 33.5122 18.2464 33.8558 18.4042C34.1995 18.56 34.5155 18.8236 34.8037 19.1951ZM34.1758 19.6822C33.9729 19.4207 33.7608 19.232 33.5396 19.116C33.3186 18.998 33.1006 18.9487 32.8855 18.9681C32.6696 18.9864 32.4679 19.0682 32.2805 19.2136C32.0931 19.359 31.9637 19.534 31.8923 19.7386C31.82 19.9421 31.813 20.1659 31.8712 20.4102C31.9297 20.6525 32.0604 20.9043 32.2633 21.1658C32.4661 21.4274 32.6781 21.6171 32.8991 21.7351C33.1203 21.8511 33.3389 21.9 33.5548 21.8817C33.7699 21.8623 33.9711 21.7799 34.1585 21.6345C34.346 21.4891 34.4758 21.3146 34.5481 21.1112C34.6195 20.9066 34.6259 20.6831 34.5674 20.4409C34.5092 20.1966 34.3786 19.9437 34.1758 19.6822Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2313 20.119L33.803 17.1518L34.513 16.6843L36.9332 18.9301L36.967 18.9079L35.9046 15.768L36.5506 15.3426L39.0182 17.5598L39.0502 17.5387L37.9422 14.4263L38.6522 13.9588L40.0234 18.2805L39.3721 18.7094L36.9587 16.6326L36.9302 16.6514L37.8827 19.6902L37.2313 20.119Z",
    fill: "#475467"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.36 15.1511L52.6685 3.77501C67.8558 -1.13112 84.2034 -1.12485 99.387 3.79295L95.6868 15.1662C82.905 11.0298 69.1449 11.0245 56.36 15.1511Z",
    fill: "#D4E7FD",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7418 5.60426L59.6904 5.4153L61.5786 8.26327L61.6287 8.25328L62.2816 4.89921L63.2303 4.71025L64.0827 8.98982L63.3388 9.13799L62.7532 6.19788L62.7135 6.20578L62.1138 9.36894L61.558 9.47965L59.7909 6.78137L59.7512 6.78928L60.3381 9.73567L59.5941 9.88384L58.7418 5.60426Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.785 6.16028C68.8428 6.62688 68.805 7.03735 68.6714 7.3917C68.5391 7.74447 68.3338 8.02757 68.0553 8.24101C67.7783 8.45426 67.4502 8.5844 67.071 8.63141C66.6918 8.67843 66.3412 8.63244 66.0191 8.49346C65.6982 8.3529 65.4298 8.12781 65.214 7.81821C64.9993 7.50703 64.8632 7.11884 64.8055 6.65366C64.7477 6.18706 64.7849 5.77738 64.9172 5.42461C65.0508 5.07026 65.256 4.78645 65.533 4.57319C65.8115 4.35976 66.1403 4.22953 66.5195 4.18252C66.8987 4.13551 67.2486 4.18158 67.5693 4.32074C67.8914 4.45972 68.1598 4.6848 68.3744 4.99598C68.5903 5.30558 68.7271 5.69368 68.785 6.16028ZM67.9963 6.25806C67.9556 5.92961 67.8698 5.65899 67.7389 5.4462C67.6093 5.23183 67.4471 5.07804 67.2523 4.98481C67.0574 4.89018 66.8422 4.85746 66.6068 4.88665C66.3713 4.91583 66.1707 5.00011 66.0047 5.13949C65.8386 5.27745 65.7182 5.46629 65.6434 5.706C65.5699 5.94413 65.5535 6.22742 65.5942 6.55587C65.6349 6.88432 65.7201 7.15573 65.8498 7.37011C65.9806 7.58289 66.1435 7.7366 66.3385 7.83124C66.5332 7.92446 66.7483 7.95647 66.9837 7.92729C67.2192 7.8981 67.4199 7.81453 67.586 7.67656C67.7519 7.53719 67.8717 7.34844 67.9452 7.11031C68.02 6.8706 68.037 6.58651 67.9963 6.25806Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2091 8.16844L69.7329 8.25375L69.4811 3.89738L70.9871 3.81035C71.4196 3.78536 71.7962 3.8511 72.1169 4.00757C72.4388 4.16255 72.6929 4.39758 72.879 4.71265C73.0651 5.02772 73.1712 5.41144 73.1973 5.86381C73.2236 6.3176 73.1617 6.71245 73.0118 7.04836C72.8633 7.38419 72.636 7.64846 72.3299 7.84116C72.0251 8.03378 71.6515 8.14287 71.2091 8.16844ZM70.4826 7.52533L71.1314 7.48784C71.4348 7.4703 71.6848 7.40037 71.8812 7.27804C72.0775 7.15429 72.2203 6.97886 72.3096 6.75174C72.3988 6.5232 72.4338 6.2423 72.4146 5.90905C72.3953 5.5758 72.3283 5.30222 72.2135 5.08832C72.0986 4.873 71.938 4.71652 71.7317 4.61888C71.5268 4.51974 71.2769 4.4787 70.9819 4.49574L70.3097 4.53459L70.4826 7.52533Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4299 8.01251L74.4381 3.64889L77.2761 3.6542L77.2749 4.31684L75.2273 4.31301L75.2251 5.49766L77.1257 5.50123L77.1244 6.16387L75.2239 6.16031L75.2216 7.35135L77.2862 7.35522L77.285 8.01786L74.4299 8.01251Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0453 8.03011L78.2809 3.67284L79.9148 3.7612C80.2496 3.7793 80.5273 3.85264 80.7479 3.98122C80.97 4.10987 81.1335 4.2823 81.2385 4.49851C81.3449 4.71338 81.3906 4.95982 81.3756 5.23782C81.3605 5.51724 81.2878 5.75656 81.1575 5.95579C81.0288 6.15367 80.8465 6.30242 80.6106 6.40205C80.3749 6.50026 80.0896 6.54031 79.7549 6.52221L78.5911 6.45928L78.6265 5.80399L79.6839 5.86117C79.8797 5.87175 80.0414 5.85347 80.1691 5.80632C80.2969 5.75775 80.3935 5.6826 80.4587 5.58086C80.5255 5.47778 80.563 5.34894 80.5714 5.19433C80.5797 5.03973 80.5564 4.90617 80.5013 4.79366C80.4463 4.67973 80.3579 4.59102 80.2361 4.52753C80.1145 4.46263 79.9551 4.42485 79.7579 4.41419L79.0345 4.37507L78.8346 8.07279L78.0453 8.03011ZM80.403 6.17744L81.3749 8.21016L80.4941 8.16253L79.5413 6.13085L80.403 6.17744Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3067 8.29436L81.4684 8.19866L83.4897 4.03743L84.4593 4.14812L85.4927 8.65808L84.6544 8.56238L83.8899 4.98382L83.856 4.97995L82.3067 8.29436ZM82.5283 6.59761L84.8146 6.85862L84.7426 7.48946L82.4563 7.22845L82.5283 6.59761Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6694 5.08475L86.7828 4.43187L90.213 5.02751L90.0996 5.68039L88.7708 5.44964L88.1376 9.09607L87.3651 8.96192L87.9983 5.31549L86.6694 5.08475Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8221 9.39754L90.7929 5.14325L93.5598 5.77463L93.4124 6.42066L91.4161 5.96515L91.1526 7.12012L93.0055 7.54293L92.8581 8.18897L91.0052 7.76615L90.7402 8.92736L92.7531 9.38667L92.6057 10.0327L89.8221 9.39754Z",
    fill: "#475467"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8931 15.2332L99.5963 3.86097C114.766 8.82272 127.985 18.4401 137.375 31.3459L127.694 38.3695C119.788 27.5081 108.661 19.4129 95.8931 15.2332Z",
    fill: "#D4E7FD",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.894 17.3194L112.203 13.6163L112.874 14.0345L111.896 15.6021L113.612 16.6718L114.589 15.1042L115.262 15.5235L112.954 19.2265L112.281 18.8072L113.262 17.2342L111.546 16.1645L110.565 17.7375L109.894 17.3194Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.024 16.7253L114.547 20.3177L113.896 19.869L116.373 16.2765L117.024 16.7253Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.469 20.2447C119.51 20.1316 119.533 20.0199 119.539 19.9097C119.546 19.7993 119.535 19.6918 119.505 19.5874C119.477 19.4838 119.429 19.3855 119.36 19.2924C119.293 19.1982 119.207 19.1116 119.103 19.0325C118.916 18.8907 118.714 18.8113 118.497 18.7943C118.28 18.7773 118.06 18.8281 117.838 18.9466C117.618 19.0648 117.409 19.2539 117.211 19.5141C117.012 19.7764 116.884 20.03 116.829 20.2749C116.773 20.5197 116.782 20.7455 116.857 20.9522C116.933 21.1578 117.068 21.3345 117.263 21.4823C117.439 21.6164 117.617 21.6985 117.798 21.7286C117.98 21.7596 118.153 21.7395 118.317 21.6684C118.483 21.5961 118.63 21.4758 118.758 21.3073L118.883 21.4376L117.94 20.7208L118.314 20.2289L119.724 21.3001L119.407 21.7175C119.181 22.0149 118.922 22.2241 118.63 22.345C118.338 22.4658 118.037 22.5009 117.726 22.45C117.416 22.3981 117.117 22.263 116.83 22.0447C116.51 21.8014 116.283 21.516 116.15 21.1885C116.02 20.8607 115.987 20.5123 116.053 20.1434C116.122 19.7742 116.295 19.4064 116.574 19.04C116.787 18.7595 117.017 18.5391 117.263 18.3787C117.511 18.2192 117.765 18.1171 118.026 18.0724C118.287 18.0267 118.545 18.0371 118.8 18.1038C119.055 18.1693 119.296 18.2884 119.524 18.4612C119.716 18.6073 119.874 18.7718 119.997 18.9547C120.121 19.1364 120.208 19.3277 120.259 19.5286C120.311 19.7304 120.325 19.9338 120.301 20.1387C120.278 20.3437 120.214 20.5414 120.11 20.732L119.469 20.2447Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.985 23.6228L121.847 20.329L122.444 20.8475L121.232 22.2419L122.759 23.5682L123.97 22.1738L124.569 22.6937L121.706 25.9875L121.108 25.4676L122.324 24.0684L120.798 22.7421L119.582 24.1413L118.985 23.6228Z",
    fill: "#475467"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.526 31.3843C146.948 44.3773 152.014 60.0195 152 76.0691L139.84 76.0581C139.852 62.5764 135.596 49.4369 127.682 38.5228L137.526 31.3843Z",
    fill: "#D4E7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.821 38.5451L137.503 31.524C146.856 44.4568 151.893 60.0089 151.9 75.969L139.94 75.9582C139.931 62.5237 135.691 49.4333 127.821 38.5451Z",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 36.742L134.789 39.5658L134.813 39.6033L138.311 38.6823L138.785 39.4112L134.287 40.4989L133.756 39.6807L136.578 36.0149L137.05 36.742Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.446 42.6081L139.254 40.477L140.64 42.9536L140.062 43.2772L139.062 41.4904L138.028 42.069L138.956 43.7275L138.378 44.0511L137.45 42.3926L136.41 42.9743L137.419 44.776L136.841 45.0996L135.446 42.6081Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.198 45.9935L141.115 44.0704L141.837 45.5393C141.984 45.8402 142.056 46.1183 142.052 46.3737C142.048 46.6303 141.977 46.8572 141.84 47.0544C141.704 47.2523 141.512 47.4125 141.262 47.5352C141.011 47.6586 140.766 47.7121 140.529 47.6957C140.293 47.6801 140.074 47.5937 139.872 47.4366C139.671 47.2788 139.497 47.0495 139.349 46.7486L138.836 45.7024L139.425 45.4132L139.891 46.3637C139.978 46.5397 140.073 46.6719 140.176 46.7603C140.281 46.8481 140.394 46.8956 140.514 46.9028C140.637 46.9107 140.768 46.8805 140.907 46.8123C141.046 46.744 141.151 46.6584 141.222 46.5554C141.295 46.4517 141.329 46.3313 141.325 46.194C141.322 46.0562 141.277 45.8986 141.19 45.7214L140.871 45.0711L137.547 46.7031L137.198 45.9935ZM139.967 47.1457L138.668 48.9868L138.279 48.1949L139.586 46.371L139.967 47.1457Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.593 47.325L142.944 48.1458L141.589 49.8864L141.606 49.9256L143.801 50.148L144.152 50.9688L141.012 50.5852L139.515 51.2253L139.205 50.5005L140.702 49.8603L142.593 47.325Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.437 57.0719L145.623 55.8391L145.847 56.5973L144.074 57.1193L144.646 59.0589L146.418 58.537L146.642 59.2973L142.456 60.5302L142.232 59.7698L144.01 59.2461L143.439 57.3065L141.661 57.8302L141.437 57.0719Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.995 61.3397L142.737 62.2956L142.564 61.5243L146.821 60.5684L146.995 61.3397Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42 65.6727C146.526 65.6157 146.618 65.5478 146.695 65.4689C146.774 65.3912 146.837 65.3035 146.884 65.2059C146.932 65.1097 146.961 65.004 146.972 64.889C146.984 64.7737 146.977 64.652 146.952 64.5237C146.907 64.2938 146.809 64.1002 146.658 63.9432C146.507 63.7861 146.309 63.678 146.064 63.619C145.821 63.561 145.54 63.5636 145.219 63.6265C144.896 63.6901 144.632 63.7948 144.427 63.9406C144.223 64.0864 144.08 64.2614 143.999 64.4656C143.918 64.6696 143.902 64.8914 143.949 65.1311C143.992 65.3486 144.071 65.5285 144.185 65.671C144.3 65.8148 144.443 65.9149 144.614 65.9712C144.785 66.0272 144.975 66.0348 145.183 65.994L145.19 66.175L144.962 65.0126L145.568 64.8934L145.909 66.6308L145.395 66.7319C145.028 66.8039 144.696 66.7881 144.398 66.6846C144.099 66.5811 143.851 66.4069 143.652 66.1622C143.455 65.9173 143.322 65.6178 143.252 65.2637C143.175 64.8693 143.195 64.5055 143.313 64.1725C143.433 63.8405 143.641 63.5588 143.936 63.3272C144.232 63.0967 144.606 62.9371 145.057 62.8483C145.403 62.7804 145.721 62.7686 146.012 62.8127C146.304 62.8583 146.561 62.951 146.786 63.0907C147.011 63.2302 147.197 63.4094 147.343 63.6283C147.49 63.847 147.591 64.0963 147.646 64.3765C147.693 64.6135 147.701 64.8412 147.672 65.0598C147.644 65.2781 147.582 65.4792 147.487 65.663C147.391 65.8482 147.267 66.0095 147.113 66.1468C146.959 66.2842 146.78 66.3896 146.575 66.463L146.42 65.6727Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.654 67.9261L147.981 67.3681L148.083 68.1521L146.25 68.3883L146.509 70.3937L148.341 70.1575L148.442 70.9436L144.115 71.5016L144.013 70.7155L145.852 70.4785L145.593 68.473L143.755 68.7101L143.654 67.9261Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_629_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 75.9998C1.4031e-06 59.9502 5.08098 44.3125 14.5147 31.3281L24.3524 38.4756C16.428 49.3825 12.16 62.5181 12.16 75.9998H0Z",
    fill: "#D4E7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100066 75.8998C0.121082 59.9397 5.17277 44.3922 14.5369 31.4678L24.2127 38.4978C16.3332 49.3788 12.0811 62.4654 12.0601 75.8998H0.100066Z",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.06833 70.1663L7.59142 69.3451L7.59545 69.3005L4.27702 67.8618L4.35542 66.996L8.56253 68.9217L8.47452 69.8936L3.99012 71.03L4.06833 70.1663Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81573 66.4709L4.50118 65.8182L4.92569 63.0121L5.58087 63.1112L5.2746 65.1358L6.44594 65.3129L6.73022 63.4338L7.3854 63.5329L7.10112 65.4121L8.27878 65.5902L8.5876 63.5488L9.24278 63.6479L8.81573 66.4709Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3747 62.864L5.10012 61.9869L5.42903 60.3839C5.49641 60.0555 5.60999 59.7917 5.76978 59.5925C5.92984 59.3919 6.12455 59.2557 6.3539 59.1838C6.58214 59.1103 6.83263 59.1015 7.10536 59.1575C7.37947 59.2137 7.60542 59.321 7.7832 59.4793C7.95988 59.6359 8.08005 59.8382 8.14372 60.0861C8.206 60.3338 8.20345 60.6219 8.13607 60.9502L7.90181 62.0919L7.25895 61.96L7.4718 60.9227C7.5112 60.7307 7.51703 60.568 7.48928 60.4347C7.46014 60.3011 7.40008 60.1946 7.3091 60.115C7.21702 60.0337 7.09514 59.9776 6.94347 59.9464C6.7918 59.9153 6.65626 59.9187 6.53684 59.9565C6.41602 59.9941 6.31523 60.0684 6.23444 60.1794C6.15227 60.2902 6.09134 60.4422 6.05165 60.6357L5.90604 61.3453L9.53359 62.0896L9.3747 62.864ZM7.89089 60.2583L10.0449 59.5975L9.86764 60.4616L7.71744 61.1036L7.89089 60.2583Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82372 58.4149L6.05496 57.5526L8.19597 57.0216L8.20701 56.9804L6.61898 55.4494L6.85021 54.5871L9.0815 56.8289L10.6538 57.2505L10.4496 58.012L8.8773 57.5903L5.82372 58.4149Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8948 53.0791L7.79117 51.5955L8.05994 50.8521L11.5404 52.1104L12.1939 50.3031L12.8171 50.5284L11.8948 53.0791Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6869 45.1667C13.1187 45.3526 13.4538 45.5927 13.692 45.8871C13.9295 46.1796 14.07 46.4999 14.1134 46.848C14.1574 47.1948 14.1039 47.5437 13.9527 47.8946C13.8016 48.2456 13.5847 48.5249 13.302 48.7326C13.0185 48.9384 12.6886 49.0561 12.3124 49.0859C11.9354 49.1138 11.5316 49.0351 11.1011 48.8497C10.6692 48.6638 10.3346 48.4246 10.0971 48.1321C9.85883 47.8377 9.71771 47.5172 9.67372 47.1704C9.63029 46.8222 9.68413 46.4727 9.83523 46.1218C9.98634 45.7708 10.203 45.4921 10.4852 45.2858C10.7679 45.0781 11.0978 44.9603 11.4747 44.9324C11.851 44.9026 12.255 44.9807 12.6869 45.1667ZM12.3726 45.8966C12.0686 45.7657 11.7917 45.703 11.542 45.7083C11.2915 45.7118 11.0768 45.774 10.8979 45.895C10.7177 46.0153 10.5807 46.1845 10.4869 46.4023C10.3931 46.6202 10.3644 46.836 10.4008 47.0496C10.4359 47.2627 10.5379 47.462 10.707 47.6477C10.8753 47.8315 11.1114 47.9889 11.4154 48.1198C11.7194 48.2506 11.9966 48.3143 12.2471 48.3108C12.4969 48.3055 12.7118 48.2426 12.892 48.1222C13.0709 48.0013 13.2073 47.8319 13.3011 47.614C13.3949 47.3961 13.4242 47.1807 13.3892 46.9676C13.3528 46.754 13.2504 46.5553 13.0821 46.3715C12.9131 46.1858 12.6766 46.0275 12.3726 45.8966Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2866 44.7483L10.8514 43.8066L11.2472 43.0542L14.4512 43.8513L14.47 43.8155L12.0229 41.5796L12.383 40.8951L15.6147 41.6442L15.6325 41.6103L13.1588 39.4205L13.5546 38.6681L16.8431 41.7897L16.48 42.4798L13.3636 41.8274L13.3477 41.8576L15.6497 44.0581L15.2866 44.7483Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_7927",
    x: 11.5068,
    y: 2.72363,
    width: 49.7549,
    height: 42.7612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_629_7927",
    x: 50.5425,
    y: -1,
    width: 54.9707,
    height: 23.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_629_7927",
    x: 92.7671,
    y: 2.73486,
    width: 49.7471,
    height: 42.7744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_629_7927",
    x: 121.682,
    y: 30.8843,
    width: 32.3184,
    height: 52.6851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_629_7927",
    x: -0.5,
    y: 28.3281,
    width: 32.3525,
    height: 52.6719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_7927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_7927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_7927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallChartImg);
export default __webpack_public_path__ + "static/media/overallChartImg.00f44be81948de37aee06920a4e4495a.svg";
export { ForwardRef as ReactComponent };